// @ts-nocheck
import { request } from 'sonata-react-components';

import type { ChangeLogData, MultiFlightEntityType } from 'sonata-static-storage/lib/common/common.types';

type ChangeLogsResponse = {
  amount: number;
  items: ChangeLogData[];
};

export async function getChangeLogs(campaignIds: string[], userId: string): Promise<ChangeLogsResponse> {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}changeLogs/${userId}/byCampaigns/${campaignIds.join(',')}`,
    {
      method: 'GET'
    }
  );
}
export async function getChangeLog(
  entity: MultiFlightEntityType,
  entityId: string,
  userId: string,
  token: Record<string, any>
): Promise<ChangeLogData[]> {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}multiflight/common/${entity}/${entityId}/${userId}/changeLog`,
    {
      method: 'GET'
    },
    token
  );
}
